import { DiscoverBackButtonRoot } from './discoverBackButton.styles';

const ChevronLeftIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<polyline points="15 18 9 12 15 6" />
	</svg>
);

const DiscoverBackButton = ({ onClick, ariaLabel }) => (
	<DiscoverBackButtonRoot type="button" onClick={onClick} aria-label={ariaLabel}>
		<ChevronLeftIcon />
	</DiscoverBackButtonRoot>
);

export default DiscoverBackButton;
